require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-kansenkaart-groot-saefthinge.json") })
        }
      }, "path---projecten-kansenkaart-groot-saefthinge");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-kansenkaart-groot-saefthinge!./.cache/json/projecten-kansenkaart-groot-saefthinge.json
// module id = 421
// module chunks = 231608221292675